import { FetchContext } from '../fetch-context';
import { AwardStatistic } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardStatistic: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<AwardStatistic> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/statistic`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardStatistic>(fetchContext.errorStore, response, 'get award statistic'));
